const VerticalLayout = () => import('@/layouts/VerticalLayout')

const faqsList = () => import('./views/list')

export default [
  {
    path: '/adminfaq',
    name: 'adminfaq',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'adminfaq',
      meta: { name: 'adminfaq', userType: 'admin', permission: 'faq_list' },
      component: faqsList
    }
    ]
  }
]
